<template>
  <HeaderBlock />
  <div class="header_back_article_container">
    <div class="header_article_text">
      <p class="header_article_date">12 сентября 2024</p>
      <p class="header_article_date">Автор: Алексей Совицкий</p>
    </div>
    <p class="header_article_question">
      что такое жидкость для вейпа и как ее выбрать?
    </p>
    <img
      class="header_article_img"
      src="@/assets/img/article_header.png"
      alt=""
    />

    <div class="article_content_block2">
      <p class="header_article_top_name">Популярные статьи</p>
      <div class="header_article_top_liest_text">
        <a class="header_article_top_text" href="/"
          >что такое жидкость для вейпа и как ее<br />
          выбрать?</a
        >
        <a class="header_article_top_text" href="/"
          >что такое жидкость для вейпа и как ее<br />
          выбрать?</a
        >
        <a class="header_article_top_text" href="/"
          >что такое жидкость для вейпа и как ее<br />
          выбрать?</a
        >
        <a class="header_article_top_text" href="/"
          >что такое жидкость для вейпа и как ее<br />
          выбрать?</a
        >
        <a class="header_article_top_text" href="/"
          >что такое жидкость для вейпа и как ее<br />
          выбрать?</a
        >
      </div>
    </div>
    <SocialMedia />
  </div>

  <div class="article_container">
    <div class="article_content_block">
      <p class="article_content_link_name">Содержание:</p>
      <div class="article_content_link_block">
        <a class="article_content_link" data-index="1. " href=""
          >Виды жидкостей для электронных сигарет</a
        >
        <a class="article_content_link" data-index="2. " href=""
          >как выбрать жидкость для электронной сигареты</a
        >
      </div>
    </div>
    <p class="article_after_block_text article_after_block_text_pos1">
      Электронные сигареты с каждым днем становятся все популярнее.
      Инновационное устройство позволяет <br />
      получать удовольствие и обеспечит более безопасное курение. Жидкость для
      электронной сигареты – это <br />
      заправка, которая обеспечит приятный вкус и аромат во время парения.
    </p>
    <div class="article_after_name_block">
      <p class="article_after_block_name">
        Виды жидкостей для электронных сигарет
      </p>
      <p class="article_after_block_text">
        Сейчас жижки для вейпа изготавливают множество производителей, продукция
        которых отличается <br />
        разнообразием вкуса и содержанием никотина. Стандартный состав вейпа:
      </p>
      <ul class="list_articles article_after_block_text">
        <p></p>
        <li>никотиновая база (отсутствует в безникотиновых заправках);</li>
        <li>вода;</li>
        <li>растительный глицерин (отвечает за насыщенность пара);</li>
        <li>натуральные, искусственные ароматизатори;</li>
        <li>
          пропиленгликоль (вязкое вещество, помогающее компонентам перемещаться
          по дыхательным путям).
        </li>
      </ul>
    </div>
    <p
      class="article_after_block_text pad_text_article5rem pad_text_article_bot40px"
    >
      В наполнитель для электронных сигарет добавляют подсластители, усилители
      вкуса и другие компоненты<br />
      системы.
    </p>
    <p
      class="article_after_block_text pad_text_article5rem pad_text_article_bot20px"
    >
      Жидкости в электронную сигарету различают по вкусовыми качествами, уровню
      никотина.
    </p>
    <p
      class="article_after_block_text pad_text_article5rem pad_text_article_bot20px"
    >
      За уровнем никотина выделяют:
    </p>
    <ul
      class="list_articles article_after_block_text pad_text_article5rem pad_text_article_bot20px"
    >
      <p></p>
      <li>
        безникотиновые – подходят пользователям, которые победили никотиновую
        зависимость, а привычка <br />
        курить осталась;
      </li>
      <li>очень легкие –доза 6-11 мг;</li>
      <li>
        легкие(12-15мг) – хороший вариант курильщикам со стажем, которые хотят
        избавиться плохой привычки;
      </li>
      <li>
        крепкие (18 мг) – самый популярный вид среди ассортимента жидкостей для
        электронных сигарет.
      </li>
      <li>очень крепкие (от 25 мг).</li>
    </ul>
    <p
      class="article_after_block_text pad_text_article5rem pad_text_article_bot20px"
    >
      За вкусовыми качествами различают:
    </p>
    <ul
      class="list_articles article_after_block_text pad_text_article5rem pad_text_article_bot20px"
    >
      <p></p>
      <li>табачные;</li>
      <li>фруктовые;</li>
      <li>коктейльные;</li>
      <li>десертные;</li>
      <li>ментоловые;</li>
      <li>без ароматизаторов;</li>
      <li>ореховые.</li>
    </ul>
    <p
      class="article_after_block_text pad_text_article5rem pad_text_article_bot40px"
    >
      К десертным вкусам относятся ароматы ванили, карамели, шоколадных
      напитков, взбитых сливок. Категория <br />
      популярна миксами вкуса десертов, различной выпечки. Помогает забыть о
      привычке курения обычных <br />
      сигарет.
    </p>
    <p
      class="article_after_block_text pad_text_article5rem pad_text_article_bot20px"
    >
      Универсальный вид – фруктовый. Отличаются необычным сочетанием фруктов,
      ягод. Фруктовые<br />
      разновидности продуктов можно разделить на:
    </p>
    <ul
      class="list_articles article_after_block_text pad_text_article5rem pad_bot12px"
    >
      <p></p>
      <li>кислые;</li>
      <li>сладкие;</li>
      <li>кисло-сладкие.</li>
    </ul>
    <p
      class="article_after_block_text pad_text_article5rem pad_text_article_bot40px"
    >
      Также на современном рынке представлены вейпы без вкуса и запаха.
    </p>
    <p
      class="article_after_block_name pad_text_article5rem pad_text_article_bot20px"
    >
      Как выбрать жидкость для электронной <br />
      сигареты
    </p>
    <p class="article_after_block_text pad_text_article5rem article_last_text">
      Выбор жидкости для вейпера зависит от потребностей курящего. Если ваша
      цель – выбрать безопаснейший <br />
      способ курения, тогда подойдет заправка с любимым вкусом, но уровень
      никотина желательно брать такой же <br />
      как в сигаретах. При решении побороть плохую привычку нужно уменьшать дозу
      каждые 4-5 месяцев. Вы <br />
      постепенно отвыкнете от вкуса, запаха табака и через некоторое время
      снизите уровень никотина к нулю.
    </p>
    <div class="article_after_block_links pad_text_article5rem">
      <a class="article_after_block_link" href="">ПРЕДЫДУЮЩАЯ СТАТЬЯ</a>
      <a class="article_after_block_link" href="">СЛЕДУЮЩАЯ СТАТЬЯ</a>
    </div>
  </div>
  <div class="propast"></div>
  <MakeorderBlock />
  <FooterBlock />
</template>

<script>
import HeaderBlock from "./stabl/HeaderBlock.vue";
import MakeorderBlock from "./stabl/MakeorderBlock.vue";
import FooterBlock from "./stabl/FooterBlock.vue";
import SocialMedia from "@/components/UI/SocialMedia.vue";
export default {
  components: {
    HeaderBlock,
    MakeorderBlock,
    FooterBlock,
    SocialMedia,
  },
  mounted() {
    // Проверка, если элементы присутствуют на странице, только тогда вешаем обработчик
    const block = document.querySelector(".article_content_block2");
    const headerQuestion = document.querySelector(".header_article_question");
    const articleContainer = document.querySelector(".article_container");

    if (block && headerQuestion && articleContainer) {
      window.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeUnmount() {
    // Используем beforeUnmount вместо beforeDestroy
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const block = document.querySelector(".article_content_block2");
      const headerQuestion = document.querySelector(".header_article_question");
      const articleContainer = document.querySelector(".article_container");

      if (!block || !headerQuestion || !articleContainer) {
        return; // Останавливаем выполнение, если элементы не найдены
      }

      const headerQuestionRect = headerQuestion.getBoundingClientRect();
      const articleContainerRect = articleContainer.getBoundingClientRect();

      const headerBottom = headerQuestionRect.bottom + window.pageYOffset;
      const containerBottom = articleContainerRect.bottom + window.pageYOffset;

      if (
        window.pageYOffset >= headerBottom &&
        window.pageYOffset + block.offsetHeight < containerBottom
      ) {
        block.style.position = "fixed";
        block.style.top = "1.25rem"; // Отступ сверху, чтобы блок не прилипал вплотную
        block.style.right = "0";
      } else if (window.pageYOffset + block.offsetHeight >= containerBottom) {
        block.style.position = "absolute";
        block.style.top = "132rem";
        block.style.right = "0";
      } else {
        block.style.position = "absolute";
        block.style.top = "16.5rem"; // Исходное положение
        block.style.right = "0";
      }
    },
  },
};
</script>
